import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Flame, AlertTriangle, TrendingDown } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <Flame className="w-8 h-8 text-red-400 mb-4" data-id="element-131" />,
    title: 'High-Heat Extrusion',
    description: 'Premium kibble is cooked at extreme temperatures, destroying natural enzymes and creating toxic byproducts before it ever hits the bowl.'
  }, {
    icon: <AlertTriangle className="w-8 h-8 text-red-400 mb-4" data-id="element-132" />,
    title: 'Glycation Damage',
    description: 'The Maillard reaction fuses proteins and sugars, creating Advanced Glycation End-products (AGEs) that accelerate cellular aging.'
  }, {
    icon: <TrendingDown className="w-8 h-8 text-red-400 mb-4" data-id="element-133" />,
    title: 'Mitochondrial Decay',
    description: "This 'Biological Sludge' clogs cellular energy production, leading to chronic inflammation, lethargy, and premature organ failure."
  }];
  return <section className="py-20 md:py-28 px-6 bg-surface relative overflow-hidden" data-id="element-134">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-96 bg-red-600/5 blur-[120px] rounded-full pointer-events-none" data-id="element-135"></div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-136">
        <FadeIn className="text-center mb-16" data-id="element-137">
          <h3 className="uppercase tracking-[0.3em] text-red-400 text-sm font-semibold mb-4" data-id="element-138">
            THE PROBLEM
          </h3>
          <h2 className="text-3xl md:text-4xl font-bold text-white max-w-3xl mx-auto leading-tight" data-id="element-139">
            The Silent Killer in the Bowl: Why Premium Kibble is Accelerating
            Aging.
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-140">
          {problems.map((problem, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-141">
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 h-full hover:bg-white/[0.07] transition-colors" data-id="element-142">
                {problem.icon}
                <h4 className="text-xl font-bold text-white mb-3" data-id="element-143">
                  {problem.title}
                </h4>
                <p className="text-body leading-relaxed" data-id="element-144">
                  {problem.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}